import React, { useEffect, useContext, useState, useRef } from 'react'

import {
  Box,
  Popover,
} from '@material-ui/core';


const EditorPopover = ({ open, onClose, children }) => {

  return (
    <Popover
      open={open}
      onClose={onClose?onClose:null}
      anchorReference="anchorPosition"
      anchorPosition={{ top: 110, left: 250 }}
      disableEnforceFocus={true}
      sx={{
        pointerEvents:"none",
        "& .MuiPaper-root" : {
          pointerEvents:"all",
        }
      }}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      >
      <Box sx={{
        userSelect:"none",
        width:"300px",
        padding:"10px",
        color:"black",
        fontSize:"12px",
        maxHeight:"calc(100vh - 200px)",
      }}>
       {children}
      </Box>
    </Popover>
  )
};

export default EditorPopover;
